import { fg } from '@atlassian/jira-feature-gating';

const JiraTimelineSavedViewTechnicalRelayprovider = {
	get(): boolean {
		return fg('jira_timeline_saved_view_technical');
	},
};

export default JiraTimelineSavedViewTechnicalRelayprovider;
